import React from 'react'
import { navigate, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import Layout from '../components/layout'
import ProjectIndex from '../components/project/index'
import SEO from '../components/seo'

const IndexPage = inject(`projectStore`, `navStore`)(
  observer(
    class IndexPage extends React.Component {
      componentWillMount() {
        const { projectStore, data } = this.props
        projectStore.init({
          projects: data.allContentfulSettings.edges[0].node.selectedProjects
        })
      }

      componentDidMount() {
        const { location, projectStore } = this.props
        if (location.state) {
          if (location.state.id) {
            projectStore.updateActiveProject(location.state.id)
          }
          navigate('/', {
            state: {},
            replace: true
          })
        }

        this.deviceCheck()
      }

      deviceCheck() {
        const { projectStore } = this.props
        if (process.browser && 'ontouchstart' in document.documentElement) {
          projectStore.setTouch(true)
        }
      }

      render() {
        const { navStore } = this.props
        const { open: navOpen, splashOpen } = navStore

        return (
          <Layout splashOpen={splashOpen}>
            <SEO />
            <ProjectIndex
              splashOpen={splashOpen}
              navOpen={navOpen}
            />
          </Layout>
        )
      }
    }
  )
)

export default IndexPage

IndexPage.propTypes = {
  data: PropTypes.object.isRequired
}

export const pageQuery = graphql`
  query pageQuery {
    allContentfulSettings {
      edges {
        node {
          id
          selectedProjects {
            id
            title
            slug
            info {
              childMarkdownRemark {
                html
              }
            }
            credits {
              childMarkdownRemark {
                html
              }
            }
            client {
              id
              name
              slug
            }
            videos {
              id
              title
              vimeoUrl
              poster {
                id
                title
                fluid(maxHeight: 720, quality: 51) {
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  }
`
